import React from 'react';
import './Background.css'

export const Background = ({ imgUrl }) => {
    return (
        <img src={imgUrl} className={"background-image"} />
    )
}
